import { type FC } from 'react';
import benchlingSyncSvg from '@/assets/images/benchling-sync.svg';

interface BenchlingSyncIconProps {
  className?: string;
}

export const BenchlingSyncIcon: FC<BenchlingSyncIconProps> = ({ className }) => {
  return (
    <img
      src={benchlingSyncSvg}
      alt="Benchling Sync"
      className={className}
      style={{
        width: '1em',
        height: '1em',
        display: 'inline-block',
        verticalAlign: 'middle',
      }}
    />
  );
};
